import { motion, useReducedMotion } from "motion/react";
import { Phone } from "lucide-react";
import { resort } from "@/data/resort";
import { HeroPhoto } from "../OptimizedImage";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function RatesCTA() {
  const reduced = useReducedMotion();

  return (
    <section
      aria-labelledby="rates-final-cta-heading"
      className="relative isolate overflow-hidden text-primary-foreground"
    >
      <motion.div
        className="absolute inset-0 -z-10"
        initial={reduced ? false : { scale: 1.08 }}
        whileInView={{ scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
      >
        <HeroPhoto
          alt="RV sites at Auburn RV Resort ready for your next stay"
          fetchPriority="auto"
          loading="lazy"
        />
      </motion.div>
      <div className="overlay-forest absolute inset-0 -z-10" />

      <div className="shell py-20 md:py-28">
        <Reveal>
          <Eyebrow tone="light">Your Site Is Waiting</Eyebrow>
        </Reveal>
        <h2 id="rates-final-cta-heading" className="display-xl mt-6 max-w-[16ch]">
          <MaskReveal>Ready to Plan Your</MaskReveal>
          <MaskReveal delay={0.08}>Stay in Auburn?</MaskReveal>
        </h2>
        <Reveal delay={0.12}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-primary-foreground/80 md:text-lg">
            Choose your dates, tell us about your RV and let our team help you find the best
            available site for your trip.
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <div className="mt-10 flex w-full flex-col gap-3 sm:flex-row sm:flex-wrap">
            <ResortLink variant="gold" href="/reservations/" className="w-full sm:w-auto">
              Check Availability
            </ResortLink>
            <ResortLink variant="onDark" href={resort.phoneHref} className="w-full sm:w-auto">
              <Phone className="size-4" strokeWidth={1.6} /> Call the Resort
            </ResortLink>
          </div>
          <p className="eyebrow mt-8 text-primary-foreground/60">
            Daily From $85 · Weekly From $504 · Monthly From $1,260
          </p>
          <p className="mt-3 text-sm text-primary-foreground/55">
            Rates vary by site size, location and availability.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
